'use client';

import { type FC } from 'react';
import type { AnnotationColorItemProps } from './AnnotationColorItem.types';
import { getClasses } from '@/_utils/classnames';
import styles from './AnnotationColorItem.module.css';

export const AnnotationColorItem: FC<AnnotationColorItemProps> = ({
  isSelected,
  color,
  onClick,
}) => {
  const annotationColorItemClasses = getClasses(styles.annotationColorItem, {
    [styles.annotationColorItemSelected]: isSelected,
    [styles.annotationColorItemRed]: color === 'red',
    [styles.annotationColorItemBlue]: color === 'blue',
    [styles.annotationColorItemBlack]: color === 'black',
    [styles.annotationColorItemGreen]: color === 'green',
  });

  return <div className={annotationColorItemClasses} onClick={onClick} />;
};
